import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circleco/compass/components/Typography";

interface UnreadIndicatorProps {
  count?: number;
}

export const UnreadIndicator = ({ count }: UnreadIndicatorProps) => {
  if (count === undefined) {
    return (
      <span
        aria-hidden="true"
        className="size-2 shrink-0 rounded-full bg-blue-600"
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      className="bg-primary flex shrink-0 rounded-full p-0.5"
    >
      <span
        className={classNames(
          "flex h-4 min-w-4 items-center justify-center rounded-full bg-blue-600",
          { "px-1": count > 9 },
        )}
      >
        <Typography variant="label-xs" color="inverse" component="span">
          {count}
        </Typography>
      </span>
    </span>
  );
};
